import { Box } from "@mui/material";
import React from "react";
import NewProductBrand from "./Components/NewProductBrand";
import NewProductBrandTable from "./Components/NewProductBrandTable";
import { useStyles } from "../../theme/styles";

const Category: React.FC = () => {
  const classes = useStyles();

  return (
    <Box sx={{ p: 2 }} className={classes.indexBox}>
      <NewProductBrand />
      <Box sx={{ height: "75px" }} />
      <NewProductBrandTable />
    </Box>
  );
};

export default Category;
